export const LOGIN_SUCCESS = 'loginSuccess';
export const PURGE_AUTH = 'logOut';
export const SET_USER_M = 'setUserM';
